import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

function getSentryEnvironment() {
  if (process.env.REACT_APP_SENTRY_ENVIRONMENT) return process.env.REACT_APP_SENTRY_ENVIRONMENT;
  if (typeof window === "undefined") return "unknown";
  if (window.location.hostname === "hana.ma" || window.location.hostname.endsWith(".hana.ma")) return "production";
  if (window.location.hostname.includes("preview.emergentagent.com")) return "preview";
  return "development";
}

function isDeployedProduction() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (host === "hana.ma" || host === "www.hana.ma") && process.env.REACT_APP_ENVIRONMENT === "production";
}

function getTraceSampleRate() {
  const configured = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE);
  if (!Number.isNaN(configured) && configured >= 0) return configured;
  return getSentryEnvironment() === "production" ? 0.1 : 0.5;
}

function redactSensitiveEvent(event) {
  if (event.request?.headers) {
    delete event.request.headers.Authorization;
    delete event.request.headers.authorization;
    delete event.request.headers.Cookie;
    delete event.request.headers.cookie;
  }
  if (event.request?.cookies) {
    event.request.cookies = "[Filtered]";
  }
  return event;
}

if (SENTRY_DSN && isDeployedProduction()) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: getSentryEnvironment(),
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sendDefaultPii: false,
    tracesSampleRate: getTraceSampleRate(),
    tracePropagationTargets: ["hana.ma", "www.hana.ma", "app.hana.ma", /^https:\/\/.*\.hana\.ma\/api/, /^https:\/\/.*\.preview\.emergentagent\.com\/api/],
    beforeSend: redactSensitiveEvent,
  });
}

export { Sentry };